import { axiosInstance } from "@helpers/axios-instance";
import type { LegalDocument, DataAwareResponse } from "@/types/types";
import { useQueryWithValidation } from "./useQueryWithValidation";

export function useDocuments(id: string) {
  return useQueryWithValidation({
    queryKey: ["documents", id],
    queryFn: async () => {
      const response = await axiosInstance({
        method: "GET",
        url:  `Salesforce/Documents/${id}`,
      });

      const data = response.data;

      return data as DataAwareResponse<LegalDocument[]>;
    },
  });
}
